/** Page size when loading pricing plans for the Activate EU DDP autocomplete. */
export const ACTIVATE_EU_DDP_PRICING_PLANS_PAGE_SIZE = 500;
